import React from 'react';
import logger from '@eb/logger-bugsnag';
import { BarGraph } from '@eb/eds-iconography';
import { Bolt } from '@eb/eds-iconography';
import { Calendar } from '@eb/eds-iconography';
import { Check } from '@eb/eds-iconography';
import { CreditCardBack } from '@eb/eds-iconography';
import { Friends } from '@eb/eds-iconography';
import { Gear } from '@eb/eds-iconography';
import { Globe } from '@eb/eds-iconography';
import { Headphone } from '@eb/eds-iconography';
import { Lock } from '@eb/eds-iconography';
import { MagnifyingGlass } from '@eb/eds-iconography';
import { Megaphone } from '@eb/eds-iconography';
import { ScreenSmall } from '@eb/eds-iconography';
import { Ticket } from '@eb/eds-iconography';
import SignupForm from '../sharedComponents/SignupForm';
import DisclaimerText from '../sharedComponents/DisclaimerText';
import CtaButton from '../sharedComponents/CtaButton';

export const SIGNUP_URL = '/signin/?referrer=%2Fcreate';

export const relativeZindexStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 100,
};

interface IconTypeDictionary {
    'bar-graph': React.ReactNode;
    bolt: React.ReactNode;
    calendar: React.ReactNode;
    check: React.ReactNode;
    'credit-card-back': React.ReactNode;
    friends: React.ReactNode;
    gear: React.ReactNode;
    globe: React.ReactNode;
    headphone: React.ReactNode;
    lock: React.ReactNode;
    'magnifying-glass': React.ReactNode;
    megaphone: React.ReactNode;
    'screen-small': React.ReactNode;
    ticket: React.ReactNode;
}

const ICON_TYPE_MAPPING: IconTypeDictionary = {
    'bar-graph': <BarGraph />,
    bolt: <Bolt />,
    calendar: <Calendar />,
    check: <Check />,
    'credit-card-back': <CreditCardBack />,
    friends: <Friends />,
    gear: <Gear />,
    globe: <Globe />,
    headphone: <Headphone />,
    lock: <Lock />,
    'magnifying-glass': <MagnifyingGlass />,
    megaphone: <Megaphone />,
    'screen-small': <ScreenSmall />,
    ticket: <Ticket />,
};

export const getIconType = (iconType: string) => {
    if (!ICON_TYPE_MAPPING.hasOwnProperty(iconType)) {
        logger.warn('Unrecognized icon type passed in', { iconType });
        return ICON_TYPE_MAPPING['magnifying-glass'];
    }
    return ICON_TYPE_MAPPING[iconType as keyof IconTypeDictionary];
};

interface CtaSigninSectionProps {
    shouldIncludeSigninFields: boolean;
    signupGridClasses: string;
    showMktgFormClass: boolean;
    buttonText: string;
}
export class CtaSigninSection extends React.PureComponent<
    CtaSigninSectionProps
> {
    render() {
        const {
            shouldIncludeSigninFields,
            signupGridClasses,
            showMktgFormClass,
            buttonText,
        } = this.props;
        return (
            <React.Fragment>
                {shouldIncludeSigninFields && (
                    <React.Fragment>
                        <SignupForm
                            buttonText={buttonText}
                            signupGridClasses={signupGridClasses}
                            showMktgFormClass={showMktgFormClass}
                        />
                        <DisclaimerText buttonText={buttonText} />
                    </React.Fragment>
                )}
                {!shouldIncludeSigninFields && (
                    <CtaButton
                        buttonText={buttonText}
                        buttonUrl={SIGNUP_URL}
                        buttonClasses={'eds-align--center'}
                    />
                )}
            </React.Fragment>
        );
    }
}
